import { render, staticRenderFns } from "./MobProductNav.vue?vue&type=template&id=3c3409c4&"
import script from "./MobProductNav.vue?vue&type=script&lang=js&"
export * from "./MobProductNav.vue?vue&type=script&lang=js&"
import style0 from "./MobProductNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports